<!--/* eslint-disable */-->
<template>
  <div>

    <vx-card class="mt-4">
      <vs-row vs-type="flex">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <company-form :companyForm="propose.config.client" title="Dados do cliente"/>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <company-form :companyForm="propose.config.guarantor" title="Dados do garantidor"/>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card class="mt-4" title="Dados da proposta">
      <vs-row class="mb-4" vs-type="flex">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">

          <vs-row class="mb-4" vs-type="flex">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Operação:</p>
              <p>{{ propose.config.operationType | formatOperationType }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Garantia:</p>
              <p>{{ propose.config.guaranteeType | formatGuarantee }}</p>
            </vs-col>
          </vs-row>
          <vs-row class="mb-4" vs-type="flex">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Período da garantia (em meses):</p>
              <p v-if="propose.config.guaranteePeriod">{{ propose.config.guaranteePeriod }}</p>
              <p v-else> - </p>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Prazo de Pagamento (em dias):</p>
              <p>{{ propose.config.paymentTerm }}</p>
            </vs-col>
          </vs-row>
          <vs-row class="mb-4" vs-type="flex">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Criador por:</p>
              <p>{{ propose.createdBy.email }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Data da proposta:</p>
              <p>{{ propose.createdAt | formatDate }}</p>
            </vs-col>
          </vs-row>
          <vs-row class="mb-4" vs-type="flex">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <p class="font-semibold">Valor total da proposta:</p>
              <p v-if="propose.config.totalAmount">R$ {{ propose.config.totalAmount | toDecimal }}</p>
            </vs-col>
          </vs-row>
          <vs-row class="mb-4" vs-type="flex">
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <vs-list>
                <vs-list-header title="Comentários" color="danger"></vs-list-header>
                <vs-list-item v-for="(row, indextr) in propose.slaMessage" :key="indextr"
                              :title="row.title" :subtitle="row.subtitle">
                  <template slot="avatar">
                  </template>
                </vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <vs-table :data="propose.config.values" noDataText="Nenhum registro encontrado." stripe>

            <template slot="thead">
              <th>Início</th>
              <th>Fim</th>
              <th>Tipo da Operação</th>
              <th>Volume (Mwmedio)</th>
              <th>Preço (R$/MWh)</th>
              <th>Submercado</th>
              <th>Tipo de Energia</th>
              <th>Volume financeiro (R$)</th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(row, indextr) in data" :key="indextr">
                <td>
                  {{ row.startDate | formatDate }}
                </td>
                <td>
                  {{ row.endDate | formatDate }}
                </td>
                <td>
                  {{ row.operationType | formatOperationType }}
                </td>
                <td>
                  {{ row.qtdMwMed | toDecimal }}
                </td>
                <td>
                  {{ row.price | toDecimal }}
                </td>
                <td>
                  {{ row.market | formatMarket }}
                </td>
                <td>
                  {{ row.energyType | formatEnergyType }}
                </td>
                <td>
                {{ row.amount | toDecimal }}
                </td>
              </vs-tr>
            </template>

          </vs-table>
        </vs-col>

      </vs-row>
    </vx-card>

    <vx-card class="mt-4" title="Anexos">
      <vs-row>
        <vs-col class="w-1/2">
          <vs-table :data="propose.files" class="mt-6" noDataText="Não há arquivos anexados" stripe>

            <template slot="header">
              <h3>
                Arquivos anexados
              </h3>
            </template>

            <template slot="thead">
              <th>Arquivos</th>
              <th>Criado Por</th>
              <th>Data</th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(row, indextr) in data" :key="indextr">
                <vs-td>
                  <a style="cursor: pointer" @click="downloadFile(row.fileName)">{{ row.fileName }}</a>
                </vs-td>
                <vs-td>{{ row.createdBy.email }}</vs-td>
                <vs-td>{{ row.createdAt | formatDateTime }}</vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card v-if="userProfile.includes('ANALYST_I9')" class="mt-4" title="Configuração da Análise de Crédito">
      <vs-row vs-justify="space-between" vs-w="12">
        <!-- Balance -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Balanço:</p>
          <p v-if="propose.config.balance" class="ml-4">{{ propose.config.balance.date }}</p>
          <vs-button v-if="propose.config.balance" class="ml-2" color="primary" icon="edit"
                     type="flat" @click="balanceChange = !balanceChange"></vs-button>

          <vs-select v-if="balanceChange || !propose.config.balance" v-model="propose.config.balance"
                     class="ml-4" @change="balanceChange = !balanceChange">
            <vs-select-item v-for="(item, index) in balances" :key="index" :text="item.date" :value="item"/>
          </vs-select>
        </vs-col>

        <!-- Serasa -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Nota Serasa:</p>
          <p v-if="propose.config.serasa" class="ml-4">{{ propose.config.serasa.valueLabel }}</p>
          <vs-button v-if="propose.config.serasa" class="ml-2" color="primary" icon="edit"
                     type="flat" @click="serasaChange = !serasaChange"></vs-button>

          <vs-select v-if="serasaChange || !propose.config.serasa" v-model="propose.config.serasa"
                     class="ml-4" @change="serasaChange = !serasaChange">>
            <vs-select-item v-for="(item, index) in serasaList" :key="index" :text="item.valueLabel" :value="item"/>
          </vs-select>
        </vs-col>

        <!-- Compliance -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Nota de Compliance:</p>
          <p v-if="propose.config.compliance"
             class="ml-4">{{ propose.config.compliance.date }} - {{ propose.config.compliance.description }}</p>
          <vs-button v-if="propose.config.compliance" color="primary" icon="edit" type="flat"
                     @click="complianceChange = !complianceChange"></vs-button>

          <vs-select v-if="complianceChange || !propose.config.compliance" v-model="propose.config.compliance"
                     class="ml-4"
                     @change="complianceChange = !complianceChange">
            <vs-select-item v-for="(item, index) in complianceList" :key="index" :text="item.date.concat(' - ' + item.description)"
                            :value="item"/>
          </vs-select>
        </vs-col>

      </vs-row>

      <vs-row vs-justify="space-between" vs-w="12">

        <!-- Penalização -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Penalização: </p>
          <div class="ml-2">
            <numeric-input
              v-model="propose.config.penalty"
              isPositive="true"
              minimumFractionDigits="0"
              size="sm"/>
          </div>
        </vs-col>

        <!-- Labor Claim -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Pendências Fiscais ou Trabalhistas:</p>
          <vs-switch v-model="propose.config.laborClaim" class="ml-2"/>
        </vs-col>

        <!-- Financial Disputes -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Pendências Comerciais ou Financeiras:</p>
          <vs-switch v-model="propose.config.financialDisputes" class="ml-2"/>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="space-between" vs-w="12">
        <!-- Resultado -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Score:</p>
          <p class="ml-1">{{ propose.config.scoreCardLabel ? propose.config.scoreCardLabel.label : "" }}</p>

          <p class="font-semibold ml-4">Nota:</p>
          <p class="ml-1">{{ propose.config.scoreValue | toDecimal }}</p>
        </vs-col>

        <!-- Recuperação Judicial -->
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <p class="font-semibold">Recuperação Judicial:</p>
          <vs-switch v-model="propose.config.judicialRehabilitation" class="ml-2"/>
        </vs-col>

        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">

        </vs-col>

      </vs-row>

      <vs-row class="mt-4">
        <vs-col>
          <vs-button v-if="propose.config" class="mb-2" @click="compute">Calcular</vs-button>
          <vs-button v-if="propose.config" class="mb-2 ml-2" @click="computeSerasa">Calcular sem balanço</vs-button>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-col>
          <span class="font-semibold">Proposta {{ propose.config.approved }}</span>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-col>
          <span class="font-semibold text-danger">{{ propose.config.reprovedBy }}</span>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-col class="mb-2" vs-align="center" vs-lg="4" vs-sm="6" vs-type="flex" vs-xs="12">
          <ul>
            <li>
              <span class="font-semibold">Resumo da proposta</span>
            </li>
            <li>
              Garantira: <span class="font-semibold">{{ propose.config.guaranteeType | formatGuarantee }}</span>
            </li>

            <li>
              Período de Garantia: <span class="font-semibold">{{ propose.config.guaranteePeriod }}</span>
            </li>

            <li>
              Prazo de Pagamento: <span class="font-semibold">{{ propose.config.paymentTerm }}</span>
            </li>

            <li>
              Garantira Recomendada: <span class="font-semibold">{{ propose.config.recommendedGuarantee }}</span>
            </li>

            <li>
              Garantira Recomendada: <span class="font-semibold">{{ propose.config.recommendedPeriod }}</span>
            </li>

            <li>
              Valor da Proposta: <span class="font-semibold">{{ propose.config.totalAmount | toDecimal }}</span>
            </li>

            <li>
              Limite do Garantidor: <span class="font-semibold">{{ propose.config.guarantorLimit | toDecimal }}</span>
            </li>
          </ul>
        </vs-col>
      </vs-row>


      <vs-row class="mt-4">
        <vs-col class="flex justify-center">
          <vs-table :data="[]" stripe>
            <template slot="header">
              <p class="font-bold">Régua de Rating</p>
            </template>

            <template slot="thead">
              <th>AAA</th>
              <th>AA</th>
              <th>A</th>
              <th>BBB</th>
              <th>BB</th>
              <th>B</th>
              <th>CCC</th>
              <th>CC</th>
            </template>

            <template slot-scope="{data}">
              <tr>
                <td>12,50</td>
                <td>25,00</td>
                <td>37,50</td>
                <td>50,00</td>
                <td>62,50</td>
                <td>75,00</td>
                <td>87,50</td>
                <td>100</td>
              </tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col class="w-1/2">
            <balanco-form
              ref="balancoForm"
              :balanceDtoTable="propose.config.balanceDtoTable"/>
        </vs-col>
        <vs-col v-if="propose.config && propose.config.scoreTable" class="w-1/2">
          <vs-table :data="propose.config.scoreTable" class="mt-6" noDataText="Nenhum registro encontrado." stripe>
              <template slot="thead">
                <th></th>
                <th>AAA</th>
                <th>AA</th>
                <th>A</th>
                <th>BBB</th>
                <th>BB</th>
                <th>B</th>
                <th>CCC</th>
                <th>CC</th>
              </template>

              <template slot-scope="{data}">
                <vs-tr v-for="(row, indextr) in data" :key="indextr">
                  <td><p class="font-semibold">{{ row.type }}</p></td>
                  <td> <i v-if="row.value === 'AAA'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'AA'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'A'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'BBB'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'BB'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'B'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'CCC'" class="far fa-check-circle fa-lg fa"/> </td>
                  <td> <i v-if="row.value === 'CC'" class="far fa-check-circle fa-lg fa"/> </td>
                </vs-tr>
              </template>
            </vs-table>
        </vs-col>
      </vs-row>

      <div v-if="isCurrentUserAssigned && propose.status === 'REVIEW'" class="vx-row mt-4">
        <vs-button class="bg-danger-gradient ml-2" size="large"
                   @click="savePropose('ALT_STEP')">Recusar Proposta</vs-button>
        <vs-button class="bg-warning-gradient ml-2" size="large" @click="returnPrompt = !returnPrompt">Retornar Proposta</vs-button>
        <vs-button class="bg-success-gradient ml-2" size="large"
                   @click="savePropose('NEXT_STEP')">Gerar Relatório</vs-button>
      </div>

    </vx-card>

    <vs-prompt
      :active.sync="returnPrompt"
      :is-valid="!counterDanger"
      accept-text="Retornar"
      cancel-text="Cancelar"
      title="Retornar"
      @accept="savePropose('RETURN')">
      <div>
        <span>Deseja retornar esta proposta para a estapa anterior?</span>
        <vs-textarea v-model="slaAction.comments" :counter-danger.sync="counterDanger" class="mt-2" counter="1000"
                     label="Motivo"/>
      </div>
    </vs-prompt>

    <div v-if="isCurrentUserAssigned" class="vx-row mt-4">
      <div class="vx-col">
        <vs-button class="bg-danger-gradient ml-2" @click="savePropose('DENIED')">Recusar Proposta</vs-button>
        <vs-button class="bg-warning-gradient ml-2" @click="returnPrompt = !returnPrompt">Retornar para Fase Anterior</vs-button>
        <vs-button class="bg-success-gradient ml-2" @click="savePropose('APPROVE')">Enviar para Análise</vs-button>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col">
        <vs-button class="bg-primary" @click="back">Voltar</vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import SerasaForm from '../../components/SerasaForm'
import CompanyForm from '../../components/CompanyForm'
import BalancoForm from '../../components/BalancoForm'
import SectorAnalysisForm from "@/components/SectorAnalysisForm"
import NumericInput from "@/components/NumericInput";
import ScoreCharts from "@/components/stats/ScoreCharts";

export default {
  name: 'PropostaAnalysis',
  props: {
    guid: String,
    proposeDb: Object,
    balancesDb: Array
  },
  components: {
    ScoreCharts,
    SectorAnalysisForm,
    SerasaForm,
    BalancoForm,
    CompanyForm,
    NumericInput,
  },
  watch: {

    proposeDb(newVal) {
      Object.assign(this.propose, newVal)
      this.loadSerasaCompliance()
      this.getFiles()
    },

    balancesDb(newVal) {
      if (Array.isArray(newVal)) {
        this.balances = newVal
      }
    }

  },
  data() {
    return {
      files: [],
      propose: {
        files: [],
        createdAt: null,
        createdBy: {
          email: null
        },
        operationType: null,
        comments: null,
        status: null,
        proposeValue: null,
        guid: null,
        config: {
          totalAmount: null,
          guarantorLimit: null,
          values: [],
          client: {
            guid: null
          },
          clientGuid: null,
          guarantor: {
            guid: null
          },
          guarantorGuid: null,
          guaranteeType: null,
          guaranteePeriod: null,
          serasa: null,
          sectorAnalysis: null,
          compliance: null,
          financialDisputes: null,
          judicialRehabilitation: null,
          penalty: null,
          laborClaim: null,
          balance: null,
          scoreTable: [],
          subfactorScores: [],
          computeWithoutBalance: false,
        },
        approved: null,
        approvedDescription: null,
        proposeCommitteeAssignList: null,
        proposeSla: [],
        lastSla: {
          description: null,
        },
        codigo: null,
        recommendedGuarantee: null,
        recommendedPeriod: null,
        userAssigned: null,
        createdByStr: null,
        flowAction: null,
        slaMessage: [],
      },
      balances: [],
      serasaList: [],
      sectorAnalysisList: [],
      promptActivo: false,
      popupActivo: false,
      analiseSetorialValues: [],
      complianceList: [],
      returnPrompt: false,
      counterDanger: false,
      balanceChange: false,
      serasaChange: false,
      complianceChange: false,
      sectorAnalysisChange: false,
      slaAction: {
        action : null,
        comments: null,
      }
    }
  },
  computed: {

    userProfile() {
      if (localStorage.currentUser) {
        let currentUser = JSON.parse(localStorage.currentUser)
        return currentUser.profile
      }
    },

    isCurrentUserAssigned() {
      if (this.propose.lastSla && this.propose.lastSla.userAssigned) {
        let user = JSON.parse(localStorage.currentUser)
        if (this.propose.lastSla.userAssigned.email === user.email)
          return true
      }
      return false
    },

  },
  methods: {

    back() {
      this.$router.push({path: '/propose'})
    },

    loadSerasaCompliance() {
      const guarantorGuid = this.propose.config.guarantor.guid

      axios.get(`${process.env.VUE_APP_API}/api/v1/serasa/${guarantorGuid}`)
        .then((response) => {
          this.serasaList = response.data
        })

      axios.get(`${process.env.VUE_APP_API}/api/v1/compliance/${guarantorGuid}`)
        .then((response) => {
          this.complianceList = response.data
        })
    },

    compute() {
      this.propose.config.computeWithoutBalance = false
      const proposeConfig = this.propose.config

      if (proposeConfig.balance == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Selecione um balanço antes de continuar.'
        })
        return
      }

      axios.post(`${process.env.VUE_APP_API}/api/v1/propose-config/compute`, proposeConfig)
        .then((response) => {
          this.propose.config = response.data
        })
        .finally(() => {
          this.$forceUpdate()
        })
    },

    computeSerasa() {
      this.propose.config.computeWithoutBalance = true
      const proposeConfig = this.propose.config
      axios.post(`${process.env.VUE_APP_API}/api/v1/propose-config/compute-serasa`, proposeConfig)
        .then((response) => {
          this.propose.config = response.data
        })
        .finally(() => {
          this.$forceUpdate()
        })
    },

    savePropose(slaAction) {
      if (slaAction === 'APPROVE' && !this.validate()) {
        return
      }
      this.updatePropose(slaAction)
    },

    updatePropose(slaAction) {
      this.slaAction.action = slaAction
      axios.put(`${process.env.VUE_APP_API}/api/v1/propose/${this.propose.guid}/step`, this.slaAction)
        .then(() => {
          if (this.propose.lastSla.status === 'REVIEW_I9') {
            this.$router.go()
          } else {
            this.$router.push({path: '/propose'})
          }
        })
    },

    validate() {
      if (this.propose.config == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Score não cálculado'
        })
        return false
      }

      let flag = true
      if (this.propose.config.scoreValue == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Score não cálculado'
        })
        flag = false
      }
      return flag
    },

    getSectorAnalysisValues() {
      if (this.$refs.sectorAnalysisForm != null) this.$refs.sectorAnalysisForm.getValues()
    },

    getFiles() {
      this.files = this.propose.files
    },

    downloadFile(row) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/file/download`, {
        params: {
          proposeGuid: this.propose.guid,
          fileName: row,
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    }

  }

}
</script>

<style scoped>
.fa {
  color: #28C76F;
}

.chart {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: scroll;
}
</style>
